// src/languages/fr.ts
export default {
  welcome: "Bienvenue à {{appName}}",
  nav: {
    home: "Accueil",
    about: "À propos",
    contact: "Contact",
  },
  buttons: {
    save: "Sauvegarder",
    cancel: "Annuler",
    delete: "Supprimer",
  },
  auth: {
    appName: "PlanifAI",
    tagline: "Maîtrise le présent, construis ton avenir."
  },
  login: {
    title: "Se connecter",
    email: "Email",
    password: "Mot de passe",
    submit: "Se connecter",
    loading: "Connexion en cours...",
    error: "Erreur de connexion",
    genericError: "Erreur lors de la connexion",
    orContinueWith: "Ou continuer avec",
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    providers: {
      google: "Google",
      apple: "Apple",
    },
  },
  register: {
    title: "Créer un compte",
    fullName: "Nom complet",
    email: "Email",
    password: "Mot de passe",
    submit: "Créer un compte",
    loading: "Création du compte...",
    error: "Erreur d'inscription",
    genericError: "Échec de l'inscription",
    haveAccount: "Vous avez déjà un compte ?",
    signIn: "Se connecter",
    accept: "J'accepte les",
    terms: "Conditions Générales",
    acceptTermsError: "Vous devez accepter les Conditions Générales"
  },

  forgotPassword: {
    title: "Réinitialiser le mot de passe",
    description: "Saisissez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe",
    emailPlaceholder: "Email",
    submit: "Envoyer le lien",
    loading: "Envoi en cours...",
    backToLogin: "Retour à la connexion",
    success: "Si un compte existe avec cet email, vous recevrez un lien de réinitialisation",
    error: "Erreur de réinitialisation",
    genericError: "Échec de l'envoi du lien",
  },

  navbar: {
    title: "Objectifs Stoïques",
    darkMode: "Basculer le mode sombre",
    logout: "Se déconnecter",
    loggingOut: "Déconnexion...",
    language: "Changer de langue",
  },
  navigation: {
    home: "Accueil",
    journal: "Journal",
    goals: "Objectifs",
    profile: "Profil",
  },

  profile: {
    title: "Mon Profil",
  },
  userDetails: {
    title: "Détails du compte",
    name: {
      label: "Nom",
      notSpecified: "Non spécifié",
    },
    email: {
      label: "Email",
      notSpecified: "Non spécifié",
    },
  },
  userProfile: {
    title: "Informations Personnelles",
    biography: {
      label: "Biographie",
      placeholder: "Parlez-nous un peu de vous...",
    },
    expectations: {
      label: "Qu'espérez-vous accomplir avec Stoic ?",
      placeholder: "Vos objectifs et attentes...",
    },
    edit: "Modifier",
    save: "Enregistrer",
    error: "Échec de la mise à jour du profil",
  },

  settings: {
    morningNotifications: "Notifications matinales",
    eveningNotifications: "Notifications du soir",
    notificationPreferences: "Préférences de notification",
    title: "Paramètres",
    darkMode: "Mode sombre",
    language: "Langue",
    notifications: "Notifications",
    languages: {
      en: "Anglais",
      es: "Espagnol",
      fr: "Français",
    },
    edit: "Modifier",
    save: "Enregistrer",
    cancel: "Annuler",
    error: "Échec de la mise à jour des paramètres",
  },
  home: {
    stats: {
      streak: {
        title: "Série actuelle",
        unit: "jours",
        weekTrend: "+2 cette semaine",
      },
      challenges: {
        title: "Défis complétés",
        progress: "40% complété",
      },
    },
    moodChart: {
      title: "Humeur hebdomadaire",
    },
  },
  weeklyHighlights: {
    title: "Réalisations de la semaine",
    highlights: {
      streak: {
        title: "Plus longue série",
        description: "7 jours consécutifs de réflexion",
      },
      achievement: {
        title: "Succès débloqué",
        description: "5 défis stoïques complétés",
      },
      goal: {
        title: "Objectif atteint",
        description: "Méditation quotidienne pendant 1 semaine",
      },
    },
  },
  challenges: {
    title: "Défis à venir",
    items: {
      negativeVisualization: {
        title: "Visualisation négative",
        description: "Pratiquez l'art d'anticiper les adversités",
      },
      dailyGratitude: {
        title: "Gratitude quotidienne",
        description: "Trouvez 3 choses pour lesquelles être reconnaissant",
      },
      morningMeditation: {
        title: "Méditation matinale",
        description: "10 minutes de réflexion au réveil",
      },
    },
  },
  subscription: {
    title: "Abonnement",
    plans: {
      free: "Plan Gratuit",
      premium: "Premium",
    },
    features: {
      ai: "Accès illimité au mentor IA",
      challenges: "Défis premium exclusifs",
      stats: "Statistiques avancées",
      reminders: "Rappels personnalisés",
      ads: "Sans publicités",
    },
    upgrade: "Passer à Premium",
  },
  quickActions: {
    dailyChallenge: "Défi Quotidien",
    newGoal: "Nouvel Objectif",
    aiConsult: "Consulter l'IA",
    viewJournal: "Voir Journal",
  },
  journal: {
    title: "Mon Journal",
    edit: "Modifier",
    cancelEdit: "Annuler la modification",
    saveSuccess: "Enregistré avec succès",
    updateSuccess: "Mis à jour avec succès",
    saveError: "Erreur lors de l'enregistrement",
    tabs: {
      morning: "Matin",
      evening: "Soir"
    },
    analysis: {
      title: "Analyse et Conseils"
    },
    metrics: {
      mood: "Humeur",
      energy: "Niveau d'énergie",
      motivation: "Motivation",
      accomplishment: "Réalisations du jour",
      reflection: "Niveau de réflexion"
    },
    prompts: {
      morning: {
        gratitude: "De quoi suis-je reconnaissant aujourd'hui ?",
        intention: "Quelle est mon intention principale pour la journée ?"
      },
      evening: {
        learnings: "Qu'ai-je appris aujourd'hui ?",
        improvements: "Que pourrais-je améliorer demain ?"
      }
    },
    placeholder: "Écrivez votre réflexion ici...",
    saveButton: "Enregistrer la réflexion",
    noEntry: "Pas d'entrée pour ce moment de la journée.",
    noReflection: "Pas de réflexion",
    editButton: "Modifier",
  },
  goals: {
    title: "Mes Objectifs",
    newGoal: "Nouvel Objectif",
    emptyState: "Vous n'avez pas encore créé d'objectifs. Créez votre premier objectif !"
  },

} as const;
